import training from "../../assets/images//choose-us/training.png";
import gymbag from "../../assets/images//choose-us/gym-bag.png";
import bottle from "../../assets/images//choose-us/bottle-of-water.png";
import bench from "../../assets/images//choose-us/bench-press.png";

const fitnessObjects = {
  training: {
    icon: training,
    description: "Free Fitness Training",
  },
  gymbag: {
    icon: gymbag,
    description: "Gym Bag Equipments",
  },
  bottle: {
    icon: bottle,
    description: "Fresh Bottle Water",
  },
  bench: {
    icon: bench,
    description: "Modern Gym Equipments",
  },
};

export default fitnessObjects;
